module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"nightMode":"Темная тема"}}')
  delete Component.options._Ctor
}
